import { createStore } from '@stencil/store';
interface WatchStore {
  avgHeartRate: number;
  watchConnected: boolean;
  heartRate: number;
}
const { state, onChange } = createStore<WatchStore>({
  avgHeartRate: 0,
  heartRate: 0,
  watchConnected: false,
});
onChange('avgHeartRate', (value) => {
  state.avgHeartRate = Math.round(value);
});
onChange('heartRate', (value) => {
  state.heartRate = Math.round(value);
});
const swWatchState = state;
export default swWatchState;
